const STORAGE_KEY = 'inbox-conversation-drafts';

function readDrafts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeDrafts(drafts) {
  try {
    if (!drafts || Object.keys(drafts).length === 0) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
  } catch {
    // Private mode or a full quota. Typing still works for this chat.
  }
}

/**
 * Full reload (F5 and Ctrl+Shift+R) starts a new page session.
 * In-app chat switches do not reload, so drafts survive those.
 * Logout wipes localStorage separately.
 */
function clearDraftsAfterReload() {
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav?.type === 'reload') localStorage.removeItem(STORAGE_KEY);
  } catch {
    // performance API missing
  }
}

clearDraftsAfterReload();

export function conversationDraftKey(platform, conversationId) {
  if (conversationId == null || conversationId === '') return null;
  return `${platform || 'whatsapp'}:${conversationId}`;
}

export function loadConversationDraft(key) {
  if (!key) return '';
  const value = readDrafts()[key];
  return typeof value === 'string' ? value : '';
}

export function saveConversationDraft(key, serialized) {
  if (!key) return;
  const drafts = readDrafts();
  const text = (serialized || '').trim();
  if (!text) delete drafts[key];
  else drafts[key] = text;
  writeDrafts(drafts);
}

export function clearConversationDrafts() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function draftToEditorHtml(serialized) {
  if (!serialized) return '';
  return serialized.replace(/\n/g, '<br>');
}
